import React from 'react';
import { Link } from 'react-router-dom';

function FakeLink(props) {

  const { typeRender, ...rest } = props

  if (typeRender === 'a') {
    let data = {};
    delete rest.to;
    data = {
      ...rest,
      href: 'javascript:void(0)'
    }
    return <a tabIndex="0" {...data}>{rest.children}</a>
  }
  else {
    return <Link {...rest}>{rest.children}</Link>
  }
}

export default FakeLink


// WEBPACK FOOTER //
// ./src/components/FakeLink/index.jsx